import React from 'react';
import { Tabs, TabList, Tab as ReachTab, TabPanels, TabPanel } from '@reach/tabs';
import './_reach.scss';
import styles from './styles.scss';

function Tab(props) {
  var classNames = [styles.tab, props.isSelected ? styles.tabSelected : '', props.className].join(' ');
  return /*#__PURE__*/React.createElement(ReachTab, Object.assign({}, props, {
    className: classNames
  }), props.children);
}

Tab.defaultProps = {
  className: null,
  isSelected: false
}; // Exports our custom Tabs component along with the default reach-ui tab and panel components.

export { Tabs, TabList, Tab, TabPanels, TabPanel };
export default Tabs;